module.exports = __webpack_public_path__ + "static/media/token_inactive.5994f67d.svg";